import SignUp from "@/pages/auth/signup";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_login/signup")({
	component: () => <SignUp />,
});
